import React from "react";

export default function MoenyIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99992 8H4.00659M11.9999 8H12.0066M2.66659 4H13.3333C14.0696 4 14.6666 4.59695 14.6666 5.33333V10.6667C14.6666 11.403 14.0696 12 13.3333 12H2.66659C1.93021 12 1.33325 11.403 1.33325 10.6667V5.33333C1.33325 4.59695 1.93021 4 2.66659 4ZM9.33325 8C9.33325 8.73638 8.7363 9.33333 7.99992 9.33333C7.26354 9.33333 6.66659 8.73638 6.66659 8C6.66659 7.26362 7.26354 6.66667 7.99992 6.66667C8.7363 6.66667 9.33325 7.26362 9.33325 8Z"
        stroke="#14B8A6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
